import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import { AltCtx, CookieBanner, Footer, Header } from "./components/site/Layout";
import PublicPage from "./pages/PublicPage";
import { ForgotPage, LoginPage, RegisterPage, ResetPage, VerifyEmailPage } from "./pages/AuthPages";
import AccountPage from "./pages/Account";
import AdminApp from "./pages/admin/AdminApp";
import GoRedirect from "./pages/GoRedirect";

const Site = ({ children }) => (
  <div className="grain flex min-h-screen flex-col">
    <Header />
    <main className="relative z-10 flex-1">{children}</main>
    <Footer />
  </div>
);

export default function App() {
  const [alts, setAlts] = useState(null);
  return (
    <AuthProvider>
      <AltCtx.Provider value={{ alts, setAlts }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/de/" replace />} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/go/:slug" element={<GoRedirect />} />
            <Route path="/:lang/login" element={<Site><LoginPage /></Site>} />
            <Route path="/:lang/register" element={<Site><RegisterPage /></Site>} />
            <Route path="/:lang/registrieren" element={<Site><RegisterPage /></Site>} />
            <Route path="/:lang/forgot-password" element={<Site><ForgotPage /></Site>} />
            <Route path="/:lang/reset-password" element={<Site><ResetPage /></Site>} />
            <Route path="/:lang/verify-email" element={<Site><VerifyEmailPage /></Site>} />
            <Route path="/de/konto" element={<Site><AccountPage /></Site>} />
            <Route path="/en/account" element={<Site><AccountPage /></Site>} />
            <Route path="*" element={<Site><PublicPage /></Site>} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </AltCtx.Provider>
    </AuthProvider>
  );
}
